import React, { useEffect } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import FormatListBulletedIcon from 'mdi-react/FormatListBulletedIcon';
import ViewGridIcon from 'mdi-react/ViewGridIcon';
import FormModal from '../../shared/components/custom/FormModal';
import ChoiceCards from '../../shared/components/custom/ChoiceCards';
import renderField from '../../shared/components/custom/Field';
import { partial } from '../../util/translation/translation';

const p = partial('appLayout');
const s = partial('shared');
const FORM_NAME = 'more_divider_form';
// As the backend allows for a divider's title
const MAX_TITLE_LENGTH = 40;

// How the app shows the items under a divider: rows, or two tiles per row
export const DIVIDER_LAYOUTS = [
  {
    value: 'list',
    label: p('dividerList'),
    icon: FormatListBulletedIcon,
  },
  {
    value: 'grid',
    label: p('dividerGrid'),
    icon: ViewGridIcon,
  },
];

let DividerForm = ({
  divider,
  title,
  handleSubmit,
  initialize,
  onClose,
  onDelete,
}) => {
  useEffect(() => {
    initialize({
      title: divider?.title || '',
      layout: divider?.layout || 'list',
    });
  }, [divider]);

  return (
    <form className="form qm-form" onSubmit={handleSubmit}>
      <div className="qm-body">
        <div className="form__form-group mb-0">
          <span className="form-header more-link__name-head">
            {p('dividerTitle')}
            <span className="more-link__count">
              {(title || '').length} / {MAX_TITLE_LENGTH}
            </span>
          </span>
          <Field
            name="title"
            component={renderField}
            placeholder={p('divider')}
            // The input itself has no maxLength: cut it here instead
            normalize={(value) => (value || '').slice(0, MAX_TITLE_LENGTH)}
          />
        </div>
        <div className="qm-section">
          <span className="qm-label">{p('dividerLayout')}</span>
          <Field
            name="layout"
            component={ChoiceCards}
            ariaLabel={p('dividerLayout')}
            options={DIVIDER_LAYOUTS}
          />
        </div>
      </div>
      <div className="qm-footer">
        {divider && (
          <button
            type="button"
            className="btn btn-outline-danger btn-sm mb-0 mr-auto"
            onClick={onDelete}
          >
            {s('delete')}
          </button>
        )}
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm mb-0"
          onClick={onClose}
        >
          {p('cancel')}
        </button>
        <button type="submit" className="btn btn-primary btn-sm mb-0">
          {divider ? s('update') : s('create')}
        </button>
      </div>
    </form>
  );
};

const selector = formValueSelector(FORM_NAME);
DividerForm = connect((state) => ({
  title: selector(state, 'title'),
}))(reduxForm({ form: FORM_NAME })(DividerForm));

// Create or edit a divider in the More menu. `divider` is the one being
// edited ({ title, layout }), or null for a new one.
const DividerModal = ({ isOpen, divider, onClose, onSave, onDelete }) => {
  const handleSubmit = (values) => {
    onSave({
      title: (values.title || '').trim(),
      layout: values.layout === 'grid' ? 'grid' : 'list',
    });
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={divider ? p('editDivider') : p('addDivider')}
      subtitle={p('dividerHint')}
    >
      <DividerForm
        divider={divider}
        onSubmit={handleSubmit}
        onClose={onClose}
        onDelete={onDelete}
      />
    </FormModal>
  );
};

export default DividerModal;
